// extracted by mini-css-extract-plugin
module.exports = {"scoreContribution":"ScoreContributionModal_score-contribution__2DXa-","content":"ScoreContributionModal_content__30UjV"};